import { useEffect, useState } from 'react';
import { getLocalStorage, setLocalStorage } from '$services/local-storage';
import { LocalStorageKeys } from '$constants';
import { getExpressDeliveryPdp } from '$services/same-day-delivery.service';
import { IExpresseDeliveryResponse } from '$models';

export const useProductSameDayDelivery = (itemNumber?: string) => {
    const [selectedZipCode, setSelectedZipCode] = useState<string>();
    const [isLoading, setIsLoading] = useState(false);
    const [sameDayDeliveryData, setSameDayDeliveryData] = useState<IExpresseDeliveryResponse | null>();

    useEffect(() => {
        getLocalStorage<string>(LocalStorageKeys.PdpSelectedZipCode).then((zipCode) => {
            setSelectedZipCode(zipCode);
        });
    }, []);

    const validateExpressAllowed = async (value: string) => {
        setIsLoading(true);
        const sameDayDeliveryData = await getExpressDeliveryPdp(itemNumber, value);
        setSameDayDeliveryData(sameDayDeliveryData);
        setIsLoading(false);
    };

    useEffect(() => {
        if (selectedZipCode && itemNumber) {
            validateExpressAllowed(selectedZipCode);
        } else if (sameDayDeliveryData) {
            setSameDayDeliveryData(null);
        }
    }, [itemNumber, selectedZipCode]);

    const onZipCodeChange = (zipCode: string) => {
        setSelectedZipCode(zipCode);
        setLocalStorage(LocalStorageKeys.PdpSelectedZipCode, zipCode);
    };

    return {
        selectedZipCode,
        onZipCodeChange,
        isLoading,
        sameDayDeliveryData,
    };
};
